/**
 * The header and nav strip that sit on top of EVERY authenticated screen.
 *
 * THE BEST VALUE PER STRING IN THE APPLICATION, and it is not close. Twenty-odd strings that a
 * foreman reads on every screen he ever opens, including the hundreds this branch has not touched.
 * Translating them is what makes a half-covered application read as "Spanish, with some English still
 * in it" rather than as "English, with a Spanish login page" — the difference between a feature
 * somebody trusts and one they route around.
 *
 * The notification bell is here rather than in a module dictionary because it is rendered by
 * AppHeader: a foreman meets these strings on the projects screen and the fleet screen too, neither of
 * which this branch has translated.
 */
export default {
  companyLogo: 'Company Logo',
  back: 'Back',
  goBack: 'Go back',
  portal: 'Portal',
  profile: 'Profile',
  admin: 'Admin',
  logout: 'Logout',
  dashboard: 'Dashboard',
  appVersion: 'App version',
  employee: 'Employee',

  // ── the notification bell ─────────────────────────────────────────────────────────────────────
  notifications: 'Notifications',
  markAllRead: 'Mark all read',
  noNotifications: 'No notifications',
  noOtherNotifications: 'No other notifications',
  // A count, so a function: the number does not have to land in the same place in another language,
  // and the plural is not the same shape either.
  actionRequired: (n) => `Action Required — ${n} report${n === 1 ? '' : 's'} awaiting approval`,
  dailyReport: 'Daily Report',
  statusLabel: 'Status',
  reviewedNeedsApproval: 'Reviewed — needs approval',
  submittedNeedsReview: 'Submitted — needs review',
  review: 'Review',
}
